import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import env from '../../config';
import users from "../../data/users";

const ExtraService = () => {

  const backendUrl = env.backendUrl;
  const [project, setProject] = useState('');
  const [supervisorName, setSupervisorName] = useState('');
  const [supervisorEmails, setSupervisorEmails] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [requestDate, setRequestDate] = useState('');
  const [serviceAddress, setServiceAddress] = useState('');
  const [serviceDescription, setServiceDescription] = useState('');
  const [referencePhotos, setReferencePhotos] = useState([]);
  const [requestType, setRequestType] = useState('service');
  const [assignedEmployee, setAssignedEmployee] = useState('1');
  const [executionDate, setExecutionDate] = useState('');
  const [servicePrice, setServicePrice] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [requestStatus, setRequestStatus] = useState('pending');
  const [evidenceStatus, setEvidenceStatus] = useState('pending');
  const [billingStatus, setBillingStatus] = useState('waiting');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const url = env.backendUrl;
  const location = useLocation();
  let stylesLoaded = false;
  const [searchParams] = useSearchParams();
  const serviceId = searchParams.get('id'); // Obtém o ID da URL
  const suggestionsRef = useRef(null); // Para o container das sugestões
  const projectInputRef = useRef(null); // Para o input de projeto
  const [projectsData, setProjectsData] = useState([]);

  useEffect(() => {
    if (project.id === undefined) {
      const today = new Date();
      const formattedDate = today.toISOString().slice(0, 10);
      // setProject({ ...project, request_date: formattedDate });
      setRequestDate(formattedDate);
    }
  }, [project.id]);

  useEffect(() => {
    fetchProjects();

    const isTailwindRoute = location.pathname.startsWith('/extraService-new');
    const isTailwindRoute2 = location.pathname.startsWith('/extraService-edit');

    if ((isTailwindRoute || isTailwindRoute2) && !stylesLoaded) {
      import('../../tailwind.css')
        .then(() => {
          stylesLoaded = true;
        })
        .catch(error => {
          console.error('Erro ao carregar estilos do Timesheet:', error);
        });
    }
  }, [location]);

  useEffect(() => {
    if (serviceId) {
      setLoading(true);
      fetch(url + `/extra-services/${serviceId}`)
        .then(response => response.json())
        .then(data => {
          setLoading(false);
          const serviceData = data.data;
          setSupervisorName(serviceData.supervisor_name || '');
          setSupervisorEmails(serviceData.supervisor_emails || '');
          setRequestDate(serviceData.request_date || '');
          setServiceAddress(serviceData.service_address || '');
          setServiceDescription(serviceData.service_description || '');
          setReferencePhotos(serviceData.reference_photos ? JSON.parse(serviceData.reference_photos).map(path => ({ path, preview: url + '/storage/' + path })) : []);
          setRequestType(serviceData.request_type || '');
          setAssignedEmployee(serviceData.assigned_employee || '');
          setExecutionDate(serviceData.execution_date || '');
          setServicePrice(serviceData.service_price || '');
          setInvoiceNumber(serviceData.invoice_number || '');
          setRequestStatus(serviceData.request_status || '');
          setEvidenceStatus(serviceData.evidence_status || '');
          setBillingStatus(serviceData.billing_status || '');
        })
        .catch(error => {
          setLoading(false);
          setError('Erro ao carregar os detalhes do serviço.');
          console.error('Erro ao buscar detalhes do serviço:', error);
        });
    }
  }, [serviceId, url]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (suggestions.length > 0 && suggestionsRef.current && !suggestionsRef.current.contains(event.target) && projectInputRef.current !== event.target) {
        setSuggestions([]);
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        setSuggestions([]);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscapeKey);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [suggestions]);

  const fetchProjects = async () => {
    try {
      const response = await axios.get(`${backendUrl}/enderecos/buscar?endereco=`);
      const projects = response.data;

      setProjectsData(projects);
      return projects;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const fillFakeData = () => {
    setSupervisorName('Nick Pense');
    setRequestDate(new Date().toISOString().slice(0, 10)); // Data de hoje
    setServiceAddress('4270 Senter Rd, San Jose, CA 95111');
    setServiceDescription('I need a fast trash removal service for my lot.');
    setRequestType('service');

    if (users.length > 0) {
      const randomUser = users[Math.floor(Math.random() * users.length)];
      setAssignedEmployee(randomUser.id);
    }
    // setExecutionDate(new Date().toISOString().slice(0, 10));
    // setServicePrice('1200.00');
    // setInvoiceNumber('INV-2025-001');
    setRequestStatus('pending');
    setBillingStatus('to_invoice');
  };

  // Função para tratar o upload das imagens
  const handleImageChange = async (e, type) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const newPhotos = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      uploading: true, // Adicionando um status de "carregando"
      uploadError: null,
      path: null,
    }));

    if (type === 'reference') {
      setReferencePhotos(prev => [...prev, ...newPhotos]);
    }

    files.forEach(async (file, index) => {
      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await axios.post(url + `/api/upload-image?subfolder=extra-services`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        const imagePath = response.data.path;
        if (type === 'reference') {
          setReferencePhotos(prev =>
            prev.map(photo =>
              photo.file === file ? { ...photo, path: imagePath, uploading: false } : photo
            )
          );
        }
      } catch (error) {
        console.error(`Erro ao fazer upload da imagem ${file.name}:`, error);
        if (type === 'reference') {
          setReferencePhotos(prev =>
            prev.map(photo =>
              photo.file === file ? { ...photo, uploading: false, uploadError: 'Erro no upload' } : photo
            )
          );
        }
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const referencePhotoPaths = referencePhotos.map(photo => photo.path).filter(path => path !== null);
    const payload = {
      supervisor_name: supervisorName,
      supervisor_emails: supervisorEmails,
      request_date: requestDate,
      service_address: serviceAddress,
      service_description: serviceDescription,
      request_type: requestType,
      assigned_employee: assignedEmployee,
      execution_date: executionDate,
      service_price: servicePrice,
      invoice_number: invoiceNumber,
      request_status: requestStatus,
      evidence_status: evidenceStatus,
      billing_status: billingStatus,
      reference_photos: JSON.stringify(referencePhotoPaths),
    };

    try {
      if (serviceId) {
        await axios.put(url + `/extra-services/${serviceId}`, payload);
      } else {
        await axios.post(url + '/extra-services', payload);
      }


      setLoading(false);
      const userId = localStorage.getItem('userId');
      navigate(`/extraService-list?userId=${userId}`);
    } catch (error) {
      setLoading(false);
      setError(`Erro ao ${serviceId ? 'atualizar' : 'criar'} o serviço. Tente novamente!`);
      console.error(`Erro ao ${serviceId ? 'atualizar' : 'criar'} o serviço:`, error);
    }
  };

  const handleProjectInputChange = (e) => {
    const inputValue = e.target.value;
    setProject(inputValue);

    if (projectsData.length > 0) {
      const filteredSuggestions = projectsData.filter(
        (p) => p.serviceAddress.toLowerCase().includes(inputValue.toLowerCase())
      );
      setSuggestions(filteredSuggestions);

    }
  };


  const handleSuggestionClick = (selectedProject) => {
    setProject(selectedProject.serviceAddress);
    setSupervisorName(selectedProject.supervisorName);
    setSupervisorEmails(selectedProject.supervisorEmails);
    setServiceAddress(selectedProject.serviceAddress);
    setSuggestions([]); // Limpa as sugestões após a seleção
    setProject('');
  };

  const handleRemoveImage = (index, type) => {
    if (type === 'reference') {
      setReferencePhotos(prev => prev.filter((_, i) => i !== index));
    }
  };

  const setExecutionDate2 = (date) => {
    if (date){
      setRequestStatus('completed');
      if(evidenceStatus === 'pending'){
        setEvidenceStatus('send');
      }

      if(billingStatus === 'waiting'){
        setBillingStatus('to_invoice');
      }
    }else{
      setRequestStatus('pending');
    }
    setExecutionDate(date);
  };

  return (
    <div className="max-w-md mx-auto p-4 space-y-4 min-h-screen">
      <h2 className="text-xl font-bold text-center">{serviceId ? 'Edit Service' : 'New Service'}</h2>

      {/* Botão para preencher dados fake */}
      <div className="flex justify-end">
        <button
          type="button"
          onClick={fillFakeData}
          className="mb-4 bg-green-500 hover:bg-green-700 text-white font-bold py-1 px-3 rounded text-sm"
        >
          Preencher Teste
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Find Address</label>
          <input
            type="text"
            value={project}
            onChange={handleProjectInputChange}
            className="w-full border p-2 rounded bg-gray-100"
            ref={projectInputRef}
          />
        </div>

        {suggestions.length > 0 && (
          <ul className="border rounded shadow-md bg-white mt-1 z-10 absolute w-full" ref={suggestionsRef}>
            {suggestions.map((suggestion) => (
              <li
                key={suggestion.id}
                className="p-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSuggestionClick(suggestion)}
              >
                {suggestion.serviceAddress}
              </li>
            ))}
          </ul>
        )}

        <div>
          <label className="block text-sm font-medium text-gray-700">Service Address (*)</label>
          <textarea
            value={serviceAddress}
            onChange={(e) => setServiceAddress(e.target.value)}
            className="w-full border p-2 rounded bg-gray-100"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Supervisor Name (*)</label>
          <input
            type="text"
            value={supervisorName}
            onChange={(e) => setSupervisorName(e.target.value)}
            className="w-full border p-2 rounded bg-gray-100"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Supervisor Email (*)</label>
          <input
            value={supervisorEmails}
            onChange={(e) => setSupervisorEmails(e.target.value)}
            className="w-full border p-2 rounded bg-gray-100 "
            required
          />
        </div>
        <div className="flex gap-4">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700">Request Date</label>
            <input
              type="date"
              value={requestDate}
              onChange={(e) => setRequestDate(e.target.value)}
              className="w-full border p-2 rounded bg-gray-100"
              required
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700">Execution Date</label>
            <input
              type="date"
              value={executionDate}
              onChange={(e) => setExecutionDate2(e.target.value)}
              className="w-full border p-2 rounded bg-gray-100"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Service Description (*)</label>
          <textarea
            value={serviceDescription}
            onChange={(e) => setServiceDescription(e.target.value)}
            className="w-full border p-2 rounded bg-gray-100"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Reference Photos</label>
          <div className="flex flex-wrap gap-2 mt-2">
            <label className="flex flex-col items-center justify-center w-20 h-20 border border-dashed border-gray-400 rounded-lg cursor-pointer text-center text-xs text-gray-500">
              +<br />Add Photo
              <input
                type="file"
                accept="image/*"
                multiple
                className="hidden"
                onChange={(e) => handleImageChange(e, 'reference')}
              />
            </label>

            {referencePhotos.map((photo, index) => (
              <div key={index} className="relative w-20 h-20">
                <img
                  src={photo.preview}
                  alt={`Reference ${index + 1}`}
                  className="w-full h-full object-cover rounded-lg"
                />
                <button
                  type="button"
                  className="absolute -top-2 -right-2 bg-white border border-gray-300 rounded-full w-5 h-5 text-xs text-black shadow"
                  onClick={() => handleRemoveImage(index, 'reference')}
                >
                  ×
                </button>
              </div>
            ))}

          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Request Type (*)</label>
          <select
            value={requestType}
            onChange={(e) => setRequestType(e.target.value)}
            className="w-full border p-2 rounded bg-gray-100"
            required
          >
            <option value="">Select Request Type</option>
            <option value="estimate">Estimate</option>
            <option value="service">Service</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Assigned Employee ID</label>
          <select
            value={assignedEmployee}
            onChange={(e) => setAssignedEmployee(e.target.value)}
            className="w-full border p-2 rounded bg-gray-100"
            required
          >
            <option value="">Select an employee</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.name}
              </option>
            ))}
          </select>
        </div>
        <div className="flex gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Service Price</label>
            <input
              type="text"
              value={servicePrice}
              onChange={(e) => setServicePrice(e.target.value)}
              className="w-full border p-2 rounded bg-gray-100"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Invoice Number</label>
            <input
              type="text"
              value={invoiceNumber}
              onChange={(e) => setInvoiceNumber(e.target.value)}
              className="w-full border p-2 rounded bg-gray-100"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Request Status (*)</label>
          <select
            value={requestStatus}
            onChange={(e) => setRequestStatus(e.target.value)}
            className="w-full border p-2 rounded bg-gray-100"
            required
          >
            <option value="">Select Request Status</option>
            <option value="pending">Pending</option>
            <option value="forwarded">Forwarded</option>
            <option value="completed">Completed</option>
            <option value="waiting_info">Waiting info</option>
            <option value="ignored">Ignored</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Billing Status (*)</label>
          <select
            value={billingStatus}
            onChange={(e) => setBillingStatus(e.target.value)}
            className="w-full border p-2 rounded bg-gray-100"
          >
            <option value="">Select billing status</option>
            <option value="waiting">Waiting</option>
            <option value="to_invoice">To Invoice</option>
            <option value="invoiced">Invoiced</option>
            <option value="no_invoice_needed">No Invoice Needed</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Evidence Status (*)</label>
          <select
            value={evidenceStatus}
            onChange={(e) => setEvidenceStatus(e.target.value)}
            className="w-full border p-2 rounded bg-gray-100"
          >
            <option value="">Select evidence status</option>
            <option value="pending">Pending</option>
            <option value="send">Send</option>
            <option value="sent">Sent</option>
            <option value="ignored">Ignored</option>
          </select>
        </div>
        <div className="text-right mt-2 text-sm text-gray-500">
          <p>(*) Required</p>
        </div>

        {/* Exibindo erro se houver */}
        {error && <p className="text-red-500">{error}</p>}

        {/* Exibindo loading */}
        {loading ? (
          <div className="text-center">Loading...</div>
        ) : (
          <div className="flex gap-4 mt-4"> {/* Adicionei mt-4 para separação do formulário */}
            <button
              type="submit"
              className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition duration-150 ease-in-out"
            >
              {serviceId ? 'Update Service' : 'Create Service'}
            </button>
            <button
              type="button"
              className="w-full bg-gray-300 hover:bg-gray-400 text-gray-700 font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-gray-400 transition duration-150 ease-in-out"
              onClick={() => navigate(-1)} // Use navigate(-1) para voltar à página anterior
            >
              Back
            </button>
          </div>

        )}
      </form>
    </div>
  );
};

export default ExtraService;
